import { composeWithDevTools } from '@redux-devtools/extension'
import { applyMiddleware, combineReducers, createStore } from 'redux'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import thunk from 'redux-thunk'
import { customerCard } from '~/rootStore/customerCard/reducer'
import { featureGate } from '~/rootStore/featureGate/reducer'
import { flippers } from '~/rootStore/flippers/reducer'
import { wallets } from '~/rootStore/wallets/reducer'
import { internalTools } from '~/sharedModules/InternalTools/reducer'
import { requestForInformation } from '~/sharedModules/RequestForInformation/reducer'
import { businessVerification } from './businessVerification/reducer'
import { deposit } from './deposit/reducer'
import { depositRequests } from './depositRequests/reducer'
import { developerTools } from './developerTools/reducer'
import { disbursements } from './disbursements/reducer'
import { saveDisbursementMiddleware } from './disbursements/storage'
import { flexpay } from './flexpay/reducer'
import { invoicing } from './indoInvoicing/reducer'
import { invoicingDetails } from './indoInvoicingDetails/reducer'
import { indoTransactionDetails } from './indoTransactionDetails/reducer'
import { indoTransactions } from './indoTransactions/reducer'
import { landingPage } from './landingPage/reducer'
import { loan } from './loan/reducer'
import { loanVerification } from './loanVerification/reducer'
import { myAccount } from './myAccount/reducer'
import { newLandingPage } from './newLandingPage/reducer'
import { onboardingFlow } from './onboardingFlow/reducer'
import { pay } from './pay/reducer'
import { route } from './route/reducer'
import { simulateDeposit } from './simulateDeposit/reducer'
import { team } from './team/reducer'
import { transactionDetails } from './transactionDetails/reducer'
import { transactions } from './transactions/reducer'
import { verificationIndo } from './verificationIndo/reducer'
import { withdraw } from './withdraw/reducer'

const rootPersistConfig = {
  key: 'root',
  storage,
  whitelist: [], // nothing whitelisted so no redux state will be persisted
}

const routePersistConfig = {
  key: 'route',
  storage,
  whitelist: [''],
}

const newLandingPagePersistConfig = {
  key: 'landingPage',
  storage,
  whitelist: ['isLebaranBannerHidden', 'isHomepageBannerDismissed'], // control lebaran banner display status
}

export const resetStore = async () => {
  await persistor.purge()
  await persistor.flush()
}

export const rootReducer = combineReducers({
  disbursements,
  myAccount,
  transactionDetails,
  deposit,
  depositRequests,
  simulateDeposit,
  withdraw,
  verificationIndo,
  developerTools,
  internalTools,
  businessVerification,
  landingPage,
  newLandingPage: persistReducer(newLandingPagePersistConfig, newLandingPage),
  route: persistReducer(routePersistConfig, route),
  transactions,
  indoTransactions,
  indoTransactionDetails,
  invoicing,
  invoicingDetails,
  team,
  requestForInformation,
  onboardingFlow,
  pay,
  flippers,
  wallets,
  loanVerification,
  flexpay,
  loan,
  featureGate,
  customerCard,
})

const persistedReducer = persistReducer(rootPersistConfig, rootReducer)
const middlewares = [thunk, saveDisbursementMiddleware]
const store = createStore(persistedReducer, composeWithDevTools(applyMiddleware(...middlewares)))
const persistor = persistStore(store)

export { persistor, store }
